import { ChangeEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  TextField,
  MenuItem,
  Select,
  Button,
  FormControlLabel,
  Box,
  Tab,
  Tabs,
  Checkbox,
  CardMedia,
  IconButton,
  Input,
  Radio,
  RadioGroup,
  Autocomplete,
  createFilterOptions,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import EditText from "../../components/editText";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

type DayOfWeek =
  | "Monday"
  | "Tuesday"
  | "Wednesday"
  | "Thursday"
  | "Friday"
  | "Saturday"
  | "Sunday";

interface Availability {
  enabled: boolean;
  start: string;
  end: string;
}

const AddProduct = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState("default");
  const [region, setRegion] = useState("default");
  const [valueTabs, setValueTabs] = useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const [description, setDescription] = useState("");
  const [fileName, setFileName] = useState<string>("");
  const [condition, setCondition] = useState<"New" | "Used">("New");
  const [color, setColor] = useState("default");
  const [bulkPrice, setBulkPrice] = useState<string>("");
  const [features, setFeatures] = useState([
    {
      logo: "/static/images/tick_icon.svg",
      title: "Verified",
      description: "Yes",
    },
  ]);
  const [featureOptions, setFeatureOptions] = useState<string[]>(["Verified"]);
  const filter = createFilterOptions<string>();
  const [editIdx, setEditIdx] = useState<number | null>(null);
  const [editDraftLogo, setEditDraftLogo] = useState<string>("");
  const [editDraftDescription, setEditDraftDescription] = useState<string>("");

  const [availability, setAvailability] = useState<
    Record<DayOfWeek, Availability>
  >({
    Monday: { enabled: true, start: "09:00", end: "18:00" },
    Tuesday: { enabled: true, start: "09:00", end: "18:00" },
    Wednesday: { enabled: true, start: "09:00", end: "18:00" },
    Thursday: { enabled: true, start: "09:00", end: "18:00" },
    Friday: { enabled: true, start: "09:00", end: "18:00" },
    Saturday: { enabled: false, start: "09:00", end: "18:00" },
    Sunday: { enabled: false, start: "09:00", end: "18:00" },
  });

  const toggleAvailability = (day: DayOfWeek) => {
    setAvailability((prev) => ({
      ...prev,
      [day]: { ...prev[day], enabled: !prev[day].enabled },
    }));
  };

  const updateTime = (
    day: DayOfWeek,
    field: "start" | "end",
    value: string
  ) => {
    setAvailability((prev) => ({
      ...prev,
      [day]: { ...prev[day], [field]: value },
    }));
  };

  return (
    <>
      <div className="main_title">
        <h1>Edit Product</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-products")}>
            Manage Product Listing
          </button>{" "}
          - Edit Product
        </p>
      </div>

      {/* <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="General Store Info" {...a11yProps(0)} />
              <Tab label="Store Availability" {...a11yProps(1)} />
            </Tabs>
          </Box>
        </div>
      </div> */}

      <div className="cards">
        <form className="form" action="">
          <div className="gap_p">
            {/* Store Image */}
            <div className="control_group w_100">
              <label htmlFor="store_image">Product Images/Videos</label>
              <div className="gap_p">
                <div className="control_group w_33">
                  {image ? (
                    <div className="upload_image no_radius v2">
                      <div className="upload_image_holder">
                        <figure>
                          <CardMedia
                            component="img"
                            image={image}
                            alt="Uploaded profile photo"
                          />
                        </figure>
                        <IconButton
                          aria-label="Remove uploaded image"
                          onClick={() => {
                            setImage("");
                            setFileName("");
                          }}
                          size="small"
                        >
                          <CloseIcon />
                        </IconButton>
                      </div>
                    </div>
                  ) : (
                    <label
                      className="upload_image no_radius v2"
                      htmlFor="store_image"
                    >
                      <Input
                        sx={{ display: "none" }}
                        id="store_image"
                        type="file"
                        inputProps={{ accept: "image/png,image/jpeg" }}
                        onChange={(event: ChangeEvent<HTMLInputElement>) => {
                          const files = (event.target as HTMLInputElement)
                            .files;
                          if (files && files[0].type.includes("image")) {
                            setFileName(files[0].name);
                            setImage(URL.createObjectURL(files[0]));
                          } else {
                            setAlertType(0);
                            setShowAlert(true);
                            setAlertMessage("This field only accepts images.");
                          }
                        }}
                      />
                      <span className="upload_image_holder">
                        <figure className="add_img">
                          <img
                            src="/static/images/placeholder.png"
                            alt="placeholder"
                          />
                          <span className="upload_img_icon">
                            <img
                              src="/static/images/edit2_icon.svg"
                              alt="Upload"
                            />
                          </span>
                        </figure>
                      </span>
                    </label>
                  )}
                </div>
              </div>
            </div>

            {/* Product Title */}
            <div className="control_group w_33">
              <label htmlFor="store_name">Product Title</label>
              <TextField
                id="store_name"
                placeholder="Enter Product Title"
                fullWidth
                hiddenLabel
              />
            </div>

            <div className="control_group w_33">
              <label htmlFor="price">Price</label>
              <TextField
                id="price"
                type="number"
                placeholder="Enter Price"
                fullWidth
                hiddenLabel
              />
            </div>

            <div className="control_group w_33">
              <label htmlFor="region">Category</label>
              <Select
                id="region"
                fullWidth
                value={region}
                onChange={(e) => setRegion(e.target.value)}
              >
                <MenuItem disabled value="default">
                  Select Category
                </MenuItem>
                <MenuItem value="newyork">Books</MenuItem>
                <MenuItem value="london">Electronic</MenuItem>
                <MenuItem value="delhi">Auto Mobiles</MenuItem>
              </Select>
            </div>
            <div className="control_group w_33">
              <label htmlFor="region">Product Type</label>
              <Select
                id="region"
                fullWidth
                value={region}
                onChange={(e) => setRegion(e.target.value)}
              >
                <MenuItem disabled value="default">
                  Select Sub Category
                </MenuItem>
                <MenuItem value="newyork">Commp.</MenuItem>
                <MenuItem value="london">Headphones</MenuItem>
                {/* <MenuItem value="delhi">Auto Mobiles</MenuItem> */}
              </Select>
            </div>

            <div className="control_group w_33">
              <label>Condition</label>
              <RadioGroup
                row
                value={condition}
                onChange={(e) => setCondition(e.target.value as "New" | "Used")}
              >
                <FormControlLabel value="New" control={<Radio />} label="New" />
                <FormControlLabel
                  value="Used"
                  control={<Radio />}
                  label="Used"
                />
              </RadioGroup>
            </div>

            <div className="control_group w_33">
              <label htmlFor="color">Color</label>
              <Select
                id="color"
                fullWidth
                value={color}
                onChange={(e) => setColor(e.target.value)}
              >
                <MenuItem disabled value="default">
                  Select Color
                </MenuItem>
                <MenuItem value="black">Black</MenuItem>
                <MenuItem value="white">White</MenuItem>
                <MenuItem value="red">Red</MenuItem>
                <MenuItem value="blue">Blue</MenuItem>
                <MenuItem value="green">Green</MenuItem>
              </Select>
            </div>

            <div className="control_group w_33">
              <label htmlFor="bulk_price">Bulk Price</label>
              <TextField
                id="bulk_price"
                type="number"
                placeholder="Enter Bulk Price"
                fullWidth
                hiddenLabel
                value={bulkPrice}
                onChange={(e) => setBulkPrice(e.target.value)}
              />
            </div>

            <div className="control_group w_33">
              <label htmlFor="region">Booster Plan</label>
              <Select
                id="region"
                fullWidth
                value={region}
                onChange={(e) => setRegion(e.target.value)}
              >
                <MenuItem disabled value="default">
                  Select Booster Plan
                </MenuItem>
                <MenuItem value="newyork">For 30 days GH£ 500</MenuItem>
                <MenuItem value="london">For 15 days GH£ 250</MenuItem>
                <MenuItem value="delhi">For 1 week GH£ 150</MenuItem>
              </Select>
            </div>

            {/* Address */}
            <div className="control_group w_66">
              <label htmlFor="store_address">Address</label>
              <TextField
                id="store_address"
                placeholder="Enter Address"
                fullWidth
                hiddenLabel
              />
            </div>

            {/* Store Code */}
            <div className="control_group w_100">
              <label htmlFor="store_code">Description</label>
              <EditText content={description} setContent={setDescription} />
            </div>

            {/* <div className="control_group w_100">
              <label htmlFor="features">Features</label>
              <div className="gap_p">
                <div className="control_group w_100">
                  <Autocomplete
                    multiple
                    freeSolo
                    options={featureOptions}
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);
                      const inputValue = params.inputValue.trim();
                      const exists = options.some(
                        (opt) => opt.toLowerCase() === inputValue.toLowerCase()
                      );
                      if (inputValue !== "" && !exists) {
                        filtered.unshift(`Add "${inputValue}"`);
                      }
                      return filtered;
                    }}
                    value={features.map((f) => f.title)}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => {
                        const chipProps = getTagProps({ index });
                        return (
                          <span
                            key={option + index}
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 4,
                            }}
                          >
                            <Chip
                              avatar={(() => {
                                const fIdx = features.findIndex(
                                  (f) => f.title === option
                                );
                                const logo =
                                  fIdx >= 0 ? features[fIdx].logo : "";
                                return logo ? (
                                  <Avatar src={logo} />
                                ) : (
                                  <Avatar>
                                    {option.charAt(0).toUpperCase()}
                                  </Avatar>
                                );
                              })()}
                              label={option}
                              onDelete={chipProps.onDelete}
                            />
                            <IconButton
                              aria-label={`Edit ${option}`}
                              size="small"
                              onClick={() => {
                                const idx = features.findIndex(
                                  (f) => f.title === option
                                );
                                if (idx >= 0) {
                                  setEditIdx(idx);
                                  setEditDraftLogo(features[idx].logo || "");
                                  setEditDraftDescription(
                                    features[idx].description || ""
                                  );
                                }
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </span>
                        );
                      })
                    }
                    onChange={(_, newValue) => {
                      const titles = (newValue || []).map((v) => {
                        const s = typeof v === "string" ? v : String(v);
                        const addMatch = s.match(/^Add \"(.*)\"$/);
                        return addMatch ? addMatch[1] : s;
                      });
                      setFeatures((prev) => {
                        const byTitle = new Map(
                          prev.map((p) => [p.title, p] as const)
                        );
                        const next = titles.map(
                          (t) =>
                            byTitle.get(t) || {
                              logo: "",
                              title: t,
                              description: "",
                            }
                        );
                        return next;
                      });
                      setFeatureOptions((prev) => {
                        const set = new Set(prev);
                        titles.forEach((t) => set.add(t));
                        return Array.from(set);
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select or type to add features"
                        hiddenLabel
                        fullWidth
                      />
                    )}
                  />
                </div>
                {editIdx !== null && (
                  <Dialog
                    open
                    onClose={() => setEditIdx(null)}
                    maxWidth="xs"
                    fullWidth
                  >
                    <DialogTitle>Edit Feature</DialogTitle>
                    <DialogContent>
                      <div className="gap_p">
                        <div className="control_group w_100">
                          <label>Logo</label>
                          {editDraftLogo ? (
                            <div className="upload_image no_radius v2">
                              <div className="upload_image_holder">
                                <figure>
                                  <CardMedia
                                    component="img"
                                    image={editDraftLogo}
                                    alt="Feature logo"
                                  />
                                </figure>
                                <IconButton
                                  aria-label="Remove uploaded image"
                                  onClick={() => setEditDraftLogo("")}
                                  size="small"
                                >
                                  <CloseIcon />
                                </IconButton>
                              </div>
                            </div>
                          ) : (
                            <label
                              className="upload_image no_radius v2"
                              htmlFor={`feature_logo_edit_input_${editIdx}`}
                            >
                              <Input
                                sx={{ display: "none" }}
                                id={`feature_logo_edit_input_${editIdx}`}
                                type="file"
                                inputProps={{ accept: "image/png,image/jpeg" }}
                                onChange={(
                                  event: ChangeEvent<HTMLInputElement>
                                ) => {
                                  const files = (
                                    event.target as HTMLInputElement
                                  ).files;
                                  if (
                                    files &&
                                    files[0] &&
                                    files[0].type.includes("image")
                                  ) {
                                    const url = URL.createObjectURL(files[0]);
                                    setEditDraftLogo(url);
                                  } else {
                                    setAlertType(0);
                                    setShowAlert(true);
                                    setAlertMessage(
                                      "This field only accepts images."
                                    );
                                  }
                                }}
                              />
                              <span className="upload_image_holder">
                                <figure className="add_img">
                                  <img
                                    src="/static/images/placeholder.png"
                                    alt="placeholder"
                                  />
                                  <span className="upload_img_icon">
                                    <img
                                      src="/static/images/edit2_icon.svg"
                                      alt="Upload"
                                    />
                                  </span>
                                </figure>
                              </span>
                            </label>
                          )}
                        </div>
                        <div className="control_group w_100">
                          <label>Description</label>
                          <TextField
                            placeholder="Enter description"
                            fullWidth
                            hiddenLabel
                            value={editDraftDescription}
                            onChange={(e) =>
                              setEditDraftDescription(e.target.value)
                            }
                          />
                        </div>
                      </div>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => setEditIdx(null)}>Cancel</Button>
                      <Button
                        className="btn btn_primary"
                        onClick={() => {
                          if (editIdx === null) return;
                          setFeatures((prev) => {
                            const copy = [...prev];
                            copy[editIdx] = {
                              ...copy[editIdx],
                              logo: editDraftLogo,
                              description: editDraftDescription,
                            };
                            return copy;
                          });
                          setEditIdx(null);
                        }}
                      >
                        Save
                      </Button>
                    </DialogActions>
                  </Dialog>
                )}
              </div>
            </div> */}
          </div>
          <div className="form_btn">
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/manage-products")}
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddProduct;
